import { encode as base64_encode, decode as base64_decode } from "base-64";

import config from "../config";
import { postApi } from "../components/Utility";
import utf8 from "utf8";
import Cookies from "js-cookie";

import { action, makeObservable, observable } from "mobx";
import { getCached, setCached, invalidateCache } from "./cacheStore";

class VehicleStore {
  total = 0;
  loading = false;
  logoFromDb = [];

  platenoImageFromDb = [];
  imeiImageFromDb = [];
  simNoImageFromDb = [];

  vehicles = [];
  assetVehicleList = [];
  getSCategories = [];
  getVehiclesUsingCompanyId = [];
  getTypeofCategory = [];
  getpollimie = [];
  getWeightUsingtId = [];
  searchdata = [];
  deviceGroups = [];
  getDeviceGroupsVehicles = [];
  vehicleRules = [];
  fuelDetails = [];
  groupList = [];
  globalSearchData = [];
  devices = [];
  vehicleTypes = [];
  wareHouse = [];
  taxiTypes = [];
  supervisor = [];
  station = [];
  customer = [];
  devicebrand = [];
  assettype = [];
  waslactivity = [];
  payment = [];
  rootStore;
  uploadExcelUrl = "/vehicle/uploadExcel";

  constructor(rootStore) {
    makeObservable(this, {
      vehicles: observable,
      logoFromDb: observable,
      platenoImageFromDb: observable,
      imeiImageFromDb: observable,
      simNoImageFromDb: observable,
      vehicleTypes: observable,
      taxiTypes: observable,
      total: observable,
      searchdata: observable,
      deviceGroups: observable,
      getDeviceGroupsVehicles: observable,
      vehicleRules: observable,
      fuelDetails: observable,
      groupList: observable,
      globalSearchData: observable,
      devices: observable,
      wareHouse: observable,
      supervisor: observable,
      station: observable,
      loadData: action,
      loadtechnicianData: action,

      loading: observable,
      // loadStatusData: action,
      getVehicleData: action,
      getVehicles: action,
      addData: action,
      addVehicleCertificate: action,
      deleteRecord: action,
      getTrailerDetails: action,
      getSFDACategories: action,
      getTypeByCategory: action,
      renewVehicle: action,
      setLogoFromDb: action,
      getVehicletypes: action,

      setPlatenoImageFromDb: observable,
      setImeiImageFromDb: observable,
      setSimNoImageFromDb: observable,

      getWeightBytId: action,
      getVehicleGroups: action,
      getTrackerId: action,
      getDeviceGroups: action,
      sampleExcel: action,
      addVehicleByExcel: action,
      getVehicleRules: action,
      getFuelCaliDetails: action,
      getDevices: action,
      getTaxiType: action,
      getVehicleGroup: action,
      getVehicleSubGroup: action,
      downloadCertificate: action,
      getDriversList: action,
      getSupervisorname: action,
      // getStationname: action,
      // getCustomername: action,
      // getdevicebrand: action,
      // getassettype: action,
      updateColumnsData: action,
      logoutVehicle: action,
      getReportsGroupVehicles: action

    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    searchField,
    status,
    isadmin,
    userId,
    usercompanyId,
    certificateType,
    // deviceFilter,
    vehicleNoSearch,
    installFrom,
    installTo,
    clearCache
  }) {
    // :${ deviceFilter }

    const cacheKey = `vehicleList:${offset}:${limit}:${companyId}:${searchField}:${status}:${usercompanyId}:${isadmin}:${userId}:${certificateType || null}:${vehicleNoSearch || null}:${installFrom || null}:${installTo || null}`;
    const cached = getCached(cacheKey);

    if (!clearCache) {
      const cached = getCached(cacheKey);

      if (cached) {
        this.vehicles = cached.vehicles;
        this.total = cached.total;
        return;
      }
    }


    this.loading = true;

    var postData = {
      // usercompanyId: "1",
      companyId: companyId,
      isadmin: isadmin,
      userId: userId,
      offset: offset,
      limit: limit,
      searchField: searchField,
      status: status,
      certificateType: certificateType,
      usercompanyId,
      // deviceFilter: deviceFilter,
      vehicleNo: vehicleNoSearch,
      installFrom: installFrom,
      installTo: installTo
    };
    //const base64Input = await base64_encode(JSON.stringify(postData));
    let vehicles;
    let total;

    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/vehicle/vehicledetails", {
          params: postData,
        });
      // .get(config.NodeUrl + "/vehicle/vehicledetails", {
      //   params: postData,
      // });
      vehicles = response?.data?.vehicleData || [];
      total = parseInt(response?.data?.TotalCount || 0);
    }
    else {
      const base64Input = await utf8.encode(JSON.stringify(postData));
      const base2 = JSON.stringify(base64_encode(base64Input));

      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=vehicledetails", "postData=" + base2);
      vehicles = response?.data?.data?.vehicledetails;
      total = parseInt(response?.data?.data?.TotalCount);

    }
    setCached(cacheKey, { vehicles, total });

    this.vehicles = vehicles;
    this.total = total;
    this.loading = false;
  }

  async loadtechnicianData({
    companyId,
    offset,
    limit,
    searchField,
    status,
    isadmin,
    userId,
    usercompanyId,
    certificateType,
  }) {
    this.loading = true;

    var postData = {
      // usercompanyId: "1",
      companyId: companyId,
      isadmin: isadmin,
      userId: userId,
      offset: offset,
      limit: limit,
      searchField: searchField,
      status: status,
      certificateType: certificateType,
      usercompanyId,
    };
    //const base64Input = await base64_encode(JSON.stringify(postData));
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));

    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=technicianvehicledetails",
        "postData=" + base2
      );

    this.vehicles = response?.data?.data?.vehicledetails;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async addData(vehicle) {
    var postData = vehicle;
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));
    var postData = vehicle.vehicle;
    var vehicleData = { postData };
    // console.log(vehicleData);
    if (config.pythonReport == 1) {

      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/vehicle/updateVehicle", vehicleData);

      // var response = await postApi
      //   .getClient("")
      //   .post("http://localhost:3061/vehicle/updateVehicle", vehicleData);

    }
    else {
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=update", "postData=" + base2);
    }
    invalidateCache('vehicleList');
    return response;
  }

  async addTechnicianData(vehicle) {
    var postData = vehicle;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=updatetechnician",
        "postData=" + base64Input
      );
    invalidateCache('vehicleList');
    return response;
  }

  async addVehicleCertificate(vehicle) {
    //vehicle.vehicleId = -1; // Ensure vehicleId is set

    var postData = { vehicle: vehicle };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=addVehicleCertificate",
        "postData=" + base64Input
      );

    invalidateCache('vehicleList');
    return response;
  }

  //For Groups in live tracking
  async getVehicleGroups(companyId, userId, isadmin) {
    var postData = { companyId, userId, isadmin };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=user&a=getusergroupvehiclesnew",
        "postData=" + base64Input
      );

    return response;
  }

  async getReportsGroupVehicles({
    deviceGroupId,
    deviceSubGroupId,
    companyId,
    userId,
    isadmin,
    subgroup,
  }) {
    var postData = {
      deviceGroupId: deviceGroupId,
      deviceSubGroupId: deviceSubGroupId,
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };

    var response = await postApi.getClient().get(config.NodeUrl + "/deviceGroup/getReportSubGroupAndVehicle", { params: postData });

    if (subgroup) {
      this.subGroupList = response?.data?.data[0]?.subgroup;
      this.getVehiclesUsingCompanyId = response?.data?.data[0]?.vehicles;
    } else {
      this.vehicles = response.data.data[0]?.vehicles;
      this.getVehiclesUsingCompanyId = response?.data?.data[0]?.vehicles;
    }

    return response.data.data[0]?.vehicles;
  }

  async getTrackerId() {
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getTrackerId");

    return response.data.data;
  }
  async getTechnicianVehicleData(vehicleId) {
    const postData = { vehicleId: vehicleId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=technicianvehicledetails",
        "postData=" + base64Input
      );

    var singleRow = response?.data?.data?.vehicledetails[0];

    //this.logoFromDb.disabled = true;

    if (singleRow.platenoImage) {
      const fileList = [
        {
          name: singleRow.platenoImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.platenoImage,
        },
      ];
      //console.log(fileList);
      this.setPlatenoImageFromDb(fileList);

      //  }
    }

    if (singleRow.simNoImage) {
      const fileList = [
        {
          name: singleRow.simNoImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.simNoImage,
        },
      ];
      //console.log(fileList);
      this.setSimNoImageFromDb(fileList);

      //  }
    }

    if (singleRow.imeiImage) {
      const fileList = [
        {
          name: singleRow.imeiImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.imeiImage,
        },
      ];
      //console.log(fileList);
      this.setImeiImageFromDb(fileList);

      //  }
    }
    return singleRow;
  }
  async getVehicleData(vehicleId) {
    const postData = { vehicleId: vehicleId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=vehicledetails", "postData=" + base64Input);

    var singleRow = response?.data?.data?.vehicledetails[0];

    //this.logoFromDb.disabled = true;

    if (singleRow.icon) {
      const fileList = [
        {
          name: singleRow.icon,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.icon,
        },
      ];
      this.setLogoFromDb(fileList);

      //  }
    }

    if (singleRow.platenoImage) {
      const fileList = [
        {
          name: singleRow.platenoImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.platenoImage,
        },
      ];
      //console.log(fileList);
      this.setPlatenoImageFromDb(fileList);

      //  }
    }

    if (singleRow.simNoImage) {
      const fileList = [
        {
          name: singleRow.simNoImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.simNoImage,
        },
      ];
      //console.log(fileList);
      this.setSimNoImageFromDb(fileList);

      //  }
    }

    if (singleRow.imeiImage) {
      const fileList = [
        {
          name: singleRow.imeiImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.imeiImage,
        },
      ];
      //console.log(fileList);
      this.setImeiImageFromDb(fileList);

      //  }
    }

    // return response?.data?.data?.vehicledetails[0];
    return singleRow;
  }

  async getVehicleDataNode(vehicleId) {
    const postData = { vehicleId: vehicleId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/vehicle/vehicledetails", {
        params: postData,
      });

    var singleRow = response?.data?.vehicleData[0];

    //this.logoFromDb.disabled = true;

    if (singleRow.icon) {
      const fileList = [
        {
          name: singleRow.icon,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.icon,
        },
      ];
      this.setLogoFromDb(fileList);

      //  }
    }

    if (singleRow.platenoImage) {
      const fileList = [
        {
          name: singleRow.platenoImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.platenoImage,
        },
      ];
      //console.log(fileList);
      this.setPlatenoImageFromDb(fileList);

      //  }
    }

    if (singleRow.simNoImage) {
      const fileList = [
        {
          name: singleRow.simNoImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.simNoImage,
        },
      ];
      //console.log(fileList);
      this.setSimNoImageFromDb(fileList);

      //  }
    }

    if (singleRow.imeiImage) {
      const fileList = [
        {
          name: singleRow.imeiImage,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.imeiImage,
        },
      ];
      //console.log(fileList);
      this.setImeiImageFromDb(fileList);

      //  }
    }

    // return response?.data?.data?.vehicledetails[0];
    return singleRow;
  }

  // use For DropDown Asset

  async getVehicles(companyId) {
    var postData = {
      tokenId: "80bovn8u800tg1aq9bvr73kbhh",
      usercompanyId: 1,
      companyId: companyId,
      isadmin: -1,
      offset: 0,
      limit: 100,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=vehicledetails", "postData=" + base64Input);

    let allVehicles = [{ vehicleId: 0, vehicleNo: "ALL" }];
    allVehicles = [...allVehicles, ...response?.data?.data?.vehicledetails];
    this.assetVehicleList = allVehicles;
    return response?.data?.data?.vehicledetails;
  }

  async getBusNo(companyId) {
    var postData = {
      tokenId: "80bovn8u800tg1aq9bvr73kbhh",
      usercompanyId: 1,
      companyId: companyId,
      isadmin: -1,
      offset: 0,
      limit: 100,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=vehicledetails", "postData=" + base64Input);

    // let allVehicles = [{ "vehicleId": 0, "vehicleNo": "ALL" }];

    this.assetVehicleList = response?.data?.data?.vehicledetails;
    return response?.data?.data?.vehicledetails;
  }

  async deleteRecord({ vehicleId, userId, full_imei }) {
    var postData = {
      tokenId: "",
      vehicle: { vehicle_id: vehicleId, userId: 1, full_imei: full_imei },
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=delete", "postData=" + base64Input);
    invalidateCache('vehicleList');
    return response;
  }

  async getCurrentGps(vehicleId) {
    var postData = { vehicleId: vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=odometer&a=getGpsOdometer", "postData=" + base64Input);

    return response?.data?.data;
  }

  async getOdometerByTime(vehicleId, datetime) {
    var postData = { datetime: datetime, vehicleId: vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=odometer&a=findOdometerByTime",
        "postData=" + base64Input
      );

    return response?.data?.data;
  }
  async getPollingImeiData() {
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getpollimie");

    this.getpollimie = response?.data?.data;
    return response?.data?.data;
  }

  // getVehicle Service use in reports
  // async getVehiclesCompanyId({ companyId }) {
  async getVehiclesCompanyId(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

    this.getVehiclesUsingCompanyId = response?.data?.data;

    return response?.data?.data;
  }

  async getVehiclesCompanyId(companyId, unassignedOnly) {
    var postData = { companyId: companyId, unassignedOnly: unassignedOnly };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles2", "postData=" + base64Input);

    this.getVehiclesUsingCompanyId = response?.data?.data;
    this.wareHouse = response?.data?.warehouse;

    return response?.data?.data;
  }

  async getDeliveryVehicles(companyId) {
    var postData = { companyId: companyId, isDelivery: 1 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

    this.getVehiclesUsingCompanyId = response?.data?.data;

    return response?.data?.data;
  }

  // To get Attach Trailer Dropdown
  async getTrailerDetails(companyId, vehicleId) {
    var postData = { companyId: companyId, vehicleId: vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=trailer&a=getTrailers", "postData=" + base64Input);

    this.getTrailerUsingCompanyId = response?.data?.data;
    return response?.data?.data;
  }

  async getWeightBytId(tId) {
    var postData = { tId: tId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=trailer&a=getWeightBytId", "postData=" + base64Input);
    this.getWeightUsingtId = response?.data?.data;
    return response?.data?.data;
  }

  //To get Storing Category
  async getSFDACategories() {
    var postData = null;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=inventory&a=getSCategories",
        "postData=" + base64Input
      );

    this.getSCategories = response?.data?.data;
    return response?.data?.data;
  }

  async getTypeByCategory(categoryId) {
    var postData = { categoryId: categoryId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=inventory&a=getTypeByCategory",
        "postData=" + base64Input
      );

    this.getTypeofCategory = response?.data?.data;
    return response?.data?.data;
  }

  async renewVehicle(renewData) {

    var response = ""

    if (config.pythonReport == 1) {

      response = await postApi
        .getClient()
        // .post("http://localhost:3061/vehicle/renewVehicle",
        .post(config.NodeUrl + "/vehicle/renewVehicle",
          { renewData }
        );

    } else {

      var postData = renewData;
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=renewVehicle", "postData=" + base64Input);

    }

    invalidateCache('vehicleList');
    return response;
  }

  async setLogoFromDb(logo) {
    this.logoFromDb = { fileList: logo };
  }
  async setImeiImageFromDb(logo) {
    this.imeiImageFromDb = { fileList: logo };
  }
  async setPlatenoImageFromDb(logo) {
    this.platenoImageFromDb = { fileList: logo };
  }
  async setSimNoImageFromDb(logo) {
    this.simNoImageFromDb = { fileList: logo };
  }

  async exportExcel(getData) {

    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/vehicle/exportVehicleExcel", getData, {
          responseType: "blob",
        });
      // .post("http://localhost:3061/vehicle/exportVehicleExcel", getData , {
      //     responseType: "blob",
      // });

      const blob = new Blob(
        [response.data],
        {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }
      );

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Vehicle_List.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } else {
      window.location.href =
        config.baseURL +
        "index.php?c=vehicle&a=vehicleExportexcel&cid=" +
        getData.cid +
        "&userId=" +
        getData.userId +
        "&isadmin=" +
        getData.isadmin +
        "&UcompanyId=" +
        getData.UcompanyId +
        "&status=" +
        getData.status +
        "&vehicleIds=" +
        getData.vehicleIds +
        "&searchField=" +
        getData.searchField +
        "&colList=" +
        getData.colList;
    }
  }

  async updateStatus(data) {
    //update active in-active
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=updateActive", "postData=" + base64Input);

    invalidateCache('vehicleList');
    return response.data;
  }

  async getDeviceGroups(companyId) {
    // var postData = { companyId: companyId, offset: 0, limit: 50, page: 1 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=company&a=getDeviceGroups", "postData=" + base64Input);
    // this.deviceGroups = response.data.data.devicegroups;
    // return response.data.data.devicegroups;

    var postData = {
      companyId: companyId,
    };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getAllGroups", {
        params: postData,
      });

    this.deviceGroups = response?.data?.data;
    return response?.data?.data;
  }

  async getDeviceGroupsofVehicles({ deviceGroupId, companyId, userId }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: "1",
      groupNameId: deviceGroupId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getGrpvehicles", "postData=" + base64Input);
    this.getDeviceGroupsVehicles =
      response?.data?.data?.getDeviceGroupsVehicles;

    this.getVehiclesUsingCompanyId =
      response?.data?.data?.getDeviceGroupsVehicles;
    return response.data.data.getDeviceGroupsVehicles;
  }

  // async sampleExcel() {
  //   window.location.href = config.fleetURL + "/appRes/sampleVehicle.xlsx";
  // }

  async sampleExcel() {
    let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;
    if (isadmin == 1) {
      window.location.href = config.fleetURL + "/appRes/sampleVehicle.xlsx";
    } else {
      window.location.href = config.fleetURL + "/appRes/vehicle.xlsx";
    }
  }

  async addVehicleByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;

    const base64Input = await base64_encode(JSON.stringify(postData));
    let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;

    if (isadmin == 1) {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/vehicle/updateImportVehicle", postData);
    } else {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/vehicle/importVehicleData", postData);
    }

    this.excelLoadig = false;
    return response.data;
  }

  async getVehicleRules(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getRules", "postData=" + base64Input);
    this.vehicleRules = response.data.data;
    return response.data.data;
  }

  async getFuelCaliDetails() {
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=fuelcalibration&a=getFuelCalibrationDetails"
      );
    this.fuelDetails = response.data.data;
    return response.data.data;
  }

  async getDevices(postData) {
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getappdevice", "postData=" + base64Input);
      // .post("index.php?c=vehicle&a=getappdevice");
    this.devices = response.data.data;
    this.mdvrServer = response.data.mdvrServer;

  }
  async getVehicletypes() {

    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicleTypes");
    this.vehicleTypes = response.data.data;

  }

  async getVehicleGroup({ companyId, userId, isadmin }) {
    var postData = { companyId: companyId, userId: userId, isadmin: isadmin };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=devicegroup&a=getVehicleGropups",
        "postData=" + base64Input
      );

    this.groupList = response.data.data;
    return response;
  }

  async getVehicleSubGroup({
    deviceGroupId,
    deviceSubGroupId,
    companyId,
    userId,
    isadmin,
    subgroup,
  }) {
    var postData = {
      deviceGroupId: deviceGroupId,
      deviceSubGroupId: deviceSubGroupId,
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=devicegroup&a=getGroups", "postData=" + base64Input);
    if (subgroup) {
      this.subGroupList = response.data.data?.subgroup;
      //this.getVehiclesUsingCompanyId = response.data.data?.vehicles;
    } else {
      this.vehicles = response.data.data?.vehicles;
      //this.getVehiclesUsingCompanyId = response.data.data?.vehicles;
    }

    return response.data.data?.vehicles;
  }

  async downloadCertificate(vid) {
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=downloadCertificatePdf&vid=" + vid);
  }

  async globalSearchList({ input, offset, limit }) {
    var postData = {
      companyId: "1",
      isadmin: "-1",
      issuperadmin: "1",
      userId: 1,
      input: input,
      offset: offset,
      limit: limit,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=globalSearch", "postData=" + base64Input);

    this.globalSearchData = response?.data?.data?.data;
  }
  async sampleExcelBulkDelete() {
    window.location.href = config.fleetURL + "/appRes/vehicleBulkDelete.xlsx";
  }

  async deleteVehicleByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;

    const base64Input = await base64_encode(JSON.stringify(postData));
    // let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;
    // let companyId = companyId;

    var response = await postApi
      .getClient("")
      // .post("http://localhost:3002/vehicle/bulkdeleteVehicle", postData);
      .post(config.NodeUrl + "/vehicle/bulkdeleteVehicle", postData);

    this.excelLoadig = false;
    return response.data;
  }

  async getDriversList(companyId) {
    // console.log(companyId,"dwee")
    var postData = {
      companyId: companyId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=getdriverList", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriversForVehicleForm", {
        params: postData,
      });
    this.getDriverName = response?.data?.drivers;

    return response?.data?.drivers;
  }
  async getTaxiType() {
    var postData = {};
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_vehicle&a=getTaxiType",
        "postData=" + base64Input
      );

    this.taxiTypes = response.data.data;
    // console.log(this.taxiTypes)
    return response.data.data;
  }

  async getSupervisorname(companyId) {
    // var postData = { companyId: companyId };w
    // console.log("This is the Post data",postData);
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/getSupervisorData", {
        companyId: companyId,
      });
    console.log(response?.data)
    this.supervisor = response?.data?.supervisors;
    this.station = response?.data?.stations;
    this.customer = response?.data?.customers;
    this.assettype = response?.data?.assetTypes;
    this.devicebrand = response?.data?.deviceBrands;
    return response?.data;
  }

  // async getStationname(companyId) {
  //   // var postData = { companyId: companyId };
  //   // console.log("This is the Post data",postData);
  //   // const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient("")
  //     .post(config.NodeUrl + "/vehicle/getStationname", {
  //       companyId: companyId,
  //     });
  //   // console.log(response?.data)
  //   this.station = response?.data;
  //   return response?.data;
  // }

  // async getCustomername(companyId) {
  //   // var postData = { companyId: companyId };
  //   // console.log("This is the Post data",postData);
  //   // const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient("")
  //     .post(config.NodeUrl + "/vehicle/getCustomername", {
  //       companyId: companyId,
  //     });
  //   // console.log(response?.data)
  //   this.customer = response?.data;
  //   return response?.data;
  // }

  // async getassettype(companyId) {
  //   // var postData = { companyId: companyId };
  //   // console.log("This is the Post data",postData);
  //   // const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient("")
  //     .post(config.NodeUrl + "/vehicle/getassettype", {
  //       companyId: companyId,
  //     });
  //   // console.log(response?.data)
  //   this.assettype = response?.data;
  //   return response?.data;
  // }

  // async getdevicebrand(companyId) {
  //   // var postData = { companyId: companyId };
  //   // console.log("This is the Post data",postData);
  //   // const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient("")
  //     .post(config.NodeUrl + "/vehicle/getdevicebrand");

  //   this.devicebrand = response?.data;

  //   return response?.data;
  // }

  async getpayment(data) {
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/payment/vehiclerenwal", { data });
    return response
  }

  async getPaymentUrl(data) {

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/payment/getPaymentUrl", { data });

    // var response = await postApi
    //   .getClient("")
    //   .post("http://localhost:3007/payment/getPaymentUrl", { data });

    if (response?.data?.success == true) {
      window.open(`${config.NodeUrl}/payment/vehiclRenewal?token=${data.token}`, "_blank")
      // window.open(`http://localhost:3007/payment/vehiclRenewal?token=${data.token}`, "_blank")
    }

    return response

  }

  async updateColumnsData(data) {
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/updateStatusForColumns", { data });

    return response
  }



  async logoutVehicle({ vehicleId }) {
    var postData = { tokenId: "", vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/logoutVehicle", postData);
    // .post("http://localhost:4000" + "/vehicle/logoutVehicle", postData);

    return response.data;
  }




}

export default VehicleStore;
